/* Rendu avis produit Univers Gousset -- badge + bandeau (ug_reviews existant) + grille
   (product-reviews-grid). Source de donnees : window.UG_REVIEWS[productId] = [avis...], un
   fichier PAR MARCHE (assets/ug-reviews-data-{locale}.js), choisi cote serveur (Liquid) selon
   request.locale.iso_code -- pas besoin d'indexer par locale en JS, le fichier charge EST deja
   la bonne langue. Zero app tierce. */
(function () {
  "use strict";

  var UGRV_LABELS = {
    "fr": { "heading": "Avis de nos clients", "word": "avis" },
    "bg": { "heading": "Отзиви от наши клиенти", "word": "отзива" },
    "da": { "heading": "Anmeldelser fra vores kunder", "word": "anmeldelser" },
    "de": { "heading": "Bewertungen unserer Kunden", "word": "Bewertungen" },
    "en": { "heading": "Reviews from our customers", "word": "reviews" },
    "es": { "heading": "Opiniones de nuestros clientes", "word": "opiniones" },
    "fi": { "heading": "Asiakkaidemme arvostelut", "word": "arvostelua" },
    "it": { "heading": "Recensioni dei nostri clienti", "word": "recensioni" },
    "nl": { "heading": "Beoordelingen van onze klanten", "word": "beoordelingen" },
    "no": { "heading": "Anmeldelser fra våre kunder", "word": "anmeldelser" },
    "pl": { "heading": "Opinie naszych klientów", "word": "recenzji" },
    "pt-PT": { "heading": "Comentários de nossos clientes", "word": "comentários" },
    "ro": { "heading": "Recenzii de la clienții noștri", "word": "recenzii" },
    "sk": { "heading": "Recenzie od našich zákazníkov", "word": "recenzií" },
    "sv": { "heading": "Recensioner från våra kunder", "word": "recensioner" },
    "tr": { "heading": "Müşterilerimizden gelen yorumlar", "word": "yorum" }
  };

  function getLabels() {
    var loc = document.body.getAttribute("data-ug-locale") || "fr";
    return UGRV_LABELS[loc] || UGRV_LABELS.fr;
  }

  function starsHtml(rating, size) {
    size = size || 14;
    var full = '<svg viewBox="0 0 18 19" width="' + size + '" height="' + size + '" fill="#3A6351" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.4 0.565613C2.41766 0.565613 0 2.98328 0 5.96561V13.1656C0 16.1479 2.41766 18.5656 5.4 18.5656H12.6C15.5823 18.5656 18 16.1479 18 13.1656V5.96561C18 2.98328 15.5823 0.565613 12.6 0.565613H5.4ZM10.3718 7.67804L9.00041 3.73275L7.62903 7.67804L3.45306 7.76314L6.78147 10.2866L5.57196 14.2844L9.00041 11.8987L12.4289 14.2844L11.2194 10.2866L14.5478 7.76314L10.3718 7.67804Z"/></svg>';
    var empty = full.replace('fill="#3A6351"', 'fill="#D8D8D8"');
    var out = "";
    for (var i = 0; i < 5; i++) out += i < rating ? full : empty;
    return out;
  }

  function getReviews(productId) {
    var data = window.UG_REVIEWS || {};
    return data[String(productId)] || null;
  }

  function renderStrip(container, reviews) {
    var track = container.querySelector(".ug-rs-track");
    if (!track) return;
    var cards = reviews.concat(reviews).map(function (r) {
      return (
        '<div class="ug-rs-card">' +
          '<div class="ug-rs-row1">' +
            '<span class="ug-rs-author">' + r.author + "</span>" +
            '<div class="ug-rs-stars">' + starsHtml(r.rating) + "</div>" +
          "</div>" +
          '<div class="ug-rs-text">' + r.reviewBody + "</div>" +
        "</div>"
      );
    });
    track.innerHTML = cards.join("");
  }

  function renderGrid(container, reviews) {
    var grid = container.querySelector("[data-ugrv-grid]");
    if (!grid) return;
    var labels = getLabels();
    var heading = container.querySelector(".ugrv-grid-heading");
    if (heading) heading.textContent = labels.heading;
    var avg = (reviews.reduce(function (s, r) { return s + r.rating; }, 0) / reviews.length).toFixed(1);
    var badge = container.querySelector("[data-ugrv-grid-badge]");
    if (badge) {
      badge.innerHTML =
        '<span class="ugrv-grid-badge-stars">' + starsHtml(Math.round(avg)) + "</span>" +
        '<span class="ugrv-grid-badge-text">' + avg + " / 5 &middot; " + reviews.length + " " + labels.word + "</span>";
    }
    grid.innerHTML = reviews.map(function (r) {
      return (
        '<div class="ugrv-grid-card">' +
          '<div class="ugrv-grid-card-top">' +
            '<span class="ugrv-grid-author">' + r.author + "</span>" +
            '<div class="ugrv-grid-stars">' + starsHtml(r.rating) + "</div>" +
          "</div>" +
          '<p class="ugrv-grid-text">' + r.reviewBody + "</p>" +
        "</div>"
      );
    }).join("");
    container.style.display = "";
  }

  function renderBadge(container, reviews) {
    var avg = (reviews.reduce(function (s, r) { return s + r.rating; }, 0) / reviews.length).toFixed(1);
    var starsC = container.querySelector("[data-ugrv-badge-stars]");
    var textC = container.querySelector("[data-ugrv-badge-text]");
    if (starsC) starsC.innerHTML = starsHtml(Math.round(avg), 15);
    if (textC) textC.textContent = avg + " (" + reviews.length + ")";
    var infoContainer = container.closest(".product__info-container") || document;
    var priceEl = infoContainer.querySelector(".price");
    if (priceEl) {
      container.style.display = "inline-flex";
      container.style.verticalAlign = "middle";
      container.style.marginLeft = "6px";
      container.style.gap = "4px";
      priceEl.style.display = "flex";
      priceEl.style.flexWrap = "wrap";
      priceEl.style.alignItems = "center";
      priceEl.style.gap = "8px";
      priceEl.appendChild(container);
    } else {
      container.style.display = "flex";
    }
  }

  function init() {
    var productId = document.body.getAttribute("data-ug-product-id");
    if (!productId) return;
    var reviews = getReviews(productId);

    var badge = document.querySelector("[data-ugrv-badge]");
    if (badge && reviews && reviews.length > 0) renderBadge(badge, reviews);

    var strip = document.querySelector("[data-ugrv-strip]");
    if (strip && reviews) renderStrip(strip, reviews);

    var gridSection = document.querySelector("[data-ugrv-grid-section]");
    if (gridSection) {
      if (reviews && reviews.length > 0) {
        renderGrid(gridSection, reviews);
      } else {
        gridSection.style.display = "none";
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
